import { render, staticRenderFns } from "./index.vue?vue&type=template&id=20d3be23&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=20d3be23&prod&scoped=true&lang=scss&external"
import style1 from "./index_gt.scss?vue&type=style&index=1&id=20d3be23&prod&scoped=true&lang=scss&external"
import style2 from "./index_pc.scss?vue&type=style&index=2&id=20d3be23&prod&scoped=true&lang=scss&external"
import style3 from "./index.vue?vue&type=style&index=3&id=20d3be23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d3be23",
  null
  
)

export default component.exports